import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import TitleScreen from "@/components/TitleScreen";
import Game from "@/components/Game";
import LeaderboardScreen from "@/components/LeaderboardScreen";
import AchievementsScreen from "@/components/AchievementsScreen";
import SpotifyEmbed from "@/components/SpotifyEmbed";

function App() {
  return (
    <div className="App min-h-screen relative">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TitleScreen />} />
          <Route path="/play" element={<Game />} />
          <Route path="/leaderboard" element={<LeaderboardScreen />} />
          <Route path="/achievements" element={<AchievementsScreen />} />
        </Routes>
        {/* Floating Spotify player — present across the app */}
        <SpotifyEmbed />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
